<template>
  <div class="app-container">
    <el-container>
      <type-tree ref="typeTree" @on-select="onSelect"></type-tree>
      <el-main class="my-main">
        <list ref="list">
          <template slot="toolbar-right">
            <el-button
              :disabled="!canCreate"
              type="primary"
              v-if="$permission.canWrite()"
              @click="create"
              icon="el-icon-plus"
              >添加</el-button
            >
            <el-button
              type="danger"
              @click="delRows"
              v-if="$permission.canDel()"
              >删除</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="showCategory()"
              v-if="$permission.canCategory()"
              >切换分类</el-button
            >
            <!--   <el-button size="mini" type="primary" plain @click="onExport">导出</el-button>
            <el-button size="mini" type="success" plain @click="onImport">导入</el-button>
            <el-button size="mini" type="success" plain @click="onImportab">导入规格信息</el-button>-->
          </template>

          <template slot="column" v-if="$permission.canRead()">
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="120"
            >
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="editById(row.RecordId)"
                  v-if="!$permission.canEdit()"
                ></el-button>

                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="editById(row.RecordId)"
                  v-if="$permission.canEdit()"
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="del(row.RecordId)"
                  v-if="$permission.canDel()"
                ></el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </el-main>
    </el-container>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <detail-dialog ref="detailDialog" @close-saved="reload"></detail-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-dialogab ref="importDialogab" @upload-success="reload" />
    <updateType-dialog
      ref="updateTypeDialog"
      @close-saved="reload"
    ></updateType-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/course/info/list";
import editDialog from "@/components/course/info/editDialog";
import detailDialog from "@/components/goods/info/detailDialog";
import typeTree from "@/components/course/info/typeTree";
import typePlatformTree from "@/components/goods/info/typePlatformTree";
import importDialog from "@/components/goods/info/importDialog";
import importDialogab from "@/components/goods/info/importDialogab";
import updateTypeDialog from "@/components/sale/mallgoods/updateTypeDialog"; //引入批量修改的界面

export default {
  name: "info",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    importDialogab,
    typeTree,
    typePlatformTree,
    detailDialog,
    updateTypeDialog,
  },
  data() {
    return {
      data: {
        TypeName: "",
        TypeId: 0,
        TypeIdChain: "",
        TypeNameChain: "",
      },
      canCreate: false,
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  mounted() {
    this.$refs.typeTree.getData();
  },
  methods: {
    showCategory() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择切换分类的数据");
        return;
      }
      let ids = rows.map((item) => item.RecordId);
      this.$refs.updateTypeDialog.open().then((that) => {
        that.getData(ids); //that表示打开的那个窗口
      });
    },
    detailById(id) {
      this.$refs.detailDialog.openDetailsById(id);
    },
    del(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => {});
    },
    onSelect(data) {
      console.log("on-select", JSON.parse(JSON.stringify(data)));
      if (data.RecordId != -1 && data.children == undefined)
        this.canCreate = true;
      else this.canCreate = false;
      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypeId = data.RecordId;
        this.data.TypeName = data.TypeName;
        this.data.TypeIdChain = data.IdChain;
        this.data.TypeNameChain = data.NameChain;
        if (data.RecordId > 0) {
          this.$refs.list.getData({ TypeIdChain: this.data.TypeIdChain });
        } else {
          this.$refs.list.getData({});
        }
      }
    },
    onSelect2(data) {
      console.log("on-select2", JSON.parse(JSON.stringify(data)));
      if (data.RecordId != -1 && data.children == undefined)
        this.canCreate = true;
      else this.canCreate = false;

      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypeplatformId = data.RecordId;
        this.data.TypeplatformName = data.TypeName;
        this.data.TypeplatformIdChain = data.IdChain;
        this.data.TypeplatformNameChain = data.NameChain;
        if (data.RecordId > 0)
          this.$refs.list.getData({
            TypeplatformIdChain: this.data.TypeplatformIdChain,
          });
        else this.$refs.list.getData({});
      }
    },
    create() {
      console.log(this.data,"create");
      this.$refs.editDialog.openCreate(this.data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => item.RecordId);
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    onImport() {
      this.$refs.importDialog.open();
    },
    onImportab() {
      this.$refs.importDialogab.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.my-main {
  padding: 0;
  padding-left: 10px;
}
</style>